import * as yup from 'yup';

import { onlyLetterRegExp, phoneRegExp } from 'utils/Validation';

export const userSchema = yup.object().shape({
  legalName: yup
    .string()
    .matches(onlyLetterRegExp, 'Recipient must only letters and not special character')
    .max(50),
  nickname: yup
    .string()
    .required('Nickname is required')
    .max(50, 'Nickname must be no more than 50 characters long'),
  email: yup.string().email('Email must be a valid email address'),
  phoneNumber: yup.string().matches(phoneRegExp, 'Please enter a valid phone number'),
  placeOfBirth: yup
    .string()
    .required('This field is required')
    .max(100, 'Place of birth must be no more than 100 characters long'),
  yearOfBirth: yup
    .number()
    .required('This field is required')
    .transform((value, originalValue) => {
      return String(originalValue).trim() === '' ? undefined : value;
    })
    .typeError('Year of birth must be a number')
    .min(1900, 'Year of birth must be no earlier than 1900')
    .max(
      new Date().getFullYear(),
      `Year of birth must be no later than ${new Date().getFullYear()}`,
    ),
  uuid: yup
    .string()
    .matches(/^[a-zA-Z0-9-_]+$/, 'ID must contain only letters, numbers, dashes or underscores')
    .max(50, 'ID must be no more than 50 characters long'),
});
